__turbopack_context__.v({
  "container": "cVim8W_container",
  "current-price": "cVim8W_current-price",
  "installment": "cVim8W_installment",
  "installment-symbol": "cVim8W_installment-symbol",
  "strike-through": "cVim8W_strike-through",
});
